
import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import NavigationBar from '../components/Navbar/navbar';
import '../styles/education-style.css';
import '../styles/responsive.css';

import Footer from '../components/Footer/footer';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import BannerVector from '../images/home-landing-page/banner-round-vector.png';

import ProfileCarousel from "../components/AICarousel/ProfileCarousel"; // Adjust the path based on your folder structure
import ChatBot9 from '../components/Chatbots/ChatBot9';

import picprivatecertifier from '../assets/images/edu/pc.png';
import pictownplanner from '../assets/images/edu/townplanner.png';
import pictownplanner2 from '../assets/images/edu/townplanner2.png';
import picelect from '../assets/images/edu/elec.png';
import picre from '../assets/images/edu/re.png';
import picbuilder from '../assets/images/edu/builder.png';

const profileData = [
  { id: 1, name: "Private Certifier", img: picprivatecertifier, type: "privatecertifer", description: "I'm here to help you with your building and construction policies. I have been trained on the NSW Complied Development Document" },
  { id: 2, name: "Town Planner Fairfield", img: pictownplanner, type: "townplannerfairfield", description: "I can guide you with DA approvals and zoning regulations." },
  { id: 3, name: "Town Planner Parramatta", img: pictownplanner2, type: "townplannerparra", description: "I specialize in urban planning and property development rules." },
  { id: 4, name: "Conveyancer", img: picbuilder, type: "conveyancer", description: "I can answer questions related to Australian Property Law." },
  { id: 5, name: "Builder", img: picelect, type: "builder", description: "I provide construction advice and building code information." },
  { id: 6, name: "Real Estate Agent", img: picre, type: "realestateagent", description: "I can help with buying, selling, and property investment." },
];

const AIConsultants = () => {
  const [selectedConsultant, setSelectedConsultant] = useState(profileData[0]); // Default to first profile
  const [clearChat, setClearChat] = useState(false); // State to trigger chat clear

  const handleBackClick = () => {
    // Navigate to the previous page or directly to "/education-home"
    if (window.history.length > 1) {
      navigate(-1); // Go to the previous page in history
    } else {
      navigate('/education-home'); // Fallback to education-home if no history
    }
  };

  const handleProfileClick = (consultant) => {
    console.log("Clicked Consultant Object:", consultant); // Log the entire object
    console.log(`Selected Consultant: ${consultant.name}, Type: ${consultant.type || "MISSING TYPE"}`);
    
    if (!consultant.type) {
      console.error(`ERROR: Consultant "${consultant.name}" is missing the "type" property!`);
    }
  
    setSelectedConsultant(consultant);
    setClearChat(true); // Trigger chat clear
  };


  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const MAX_RESULTS = 20;

  const handleLoginClick = () =>
  {
    navigate('/login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-home-user');
  };

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "275px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "175px",
        },
      },
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 2,
          centerPadding: "75px",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
  }, [username]);




  return (
    <div>
      {username ? (<DashboardNavbar prefix={''} />) : (<NavigationBar handleLoginClick={handleLoginClick} handleSignupClick={handleSignupClick} prefix={''} />)}

      <section className="connect-with-clients blue_bg_section" style={{ paddingTop: 20 }}>
        <div className="container">
            <div className="row">
            <div className="col-sm-12 d-flex flex-column align-items-center">
              <div className="d-flex align-items-center w-100" style={{ justifyContent: 'space-between' }}>
                  <button className="back-button" onClick={handleBackClick}>
                      <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                      Back
                  </button>

              </div>
              <h2 className="text-center" style={{ margin: 0 }}>
                      AI Consultants
                  </h2>
              <p className="mt-2 text-center">
                  Ask an AI Expert or get great tips on the building process!
              </p>
          </div>
            </div>
        </div>
    </section>




      {/* Profile Carousel */}
      <section className="search-banner">
        <ProfileCarousel profileData={profileData} onProfileClick={handleProfileClick} />
      </section>

      {/* ChatBot Section */}
      <section className="search-banner">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
            <ChatBot9 
                selectedConsultant={selectedConsultant} 
                clearMessages={clearChat} 
                onClear={() => setClearChat(false)} 
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIConsultants;